<template>
	<div class="bigs">
		<!-- <div class="aaa"> -->
		<navigation></navigation>
		<!-- <img src="../../../assets/img/homePage/headLogo.png" />
			<div>联系我们</div>
			<div>下载APP</div> -->
		<!-- </div> -->
		<div class="navs">
			<van-swipe :autoplay="3000">
				<van-swipe-item style="height: 2.36rem;" v-for="(image, index) in form.bannerList" :key="index">
					<img style="width: 100%;" @click="wheelClick(image.contentType, image.contentId)" v-lazy="image.imgUrl" />
				</van-swipe-item>
			</van-swipe>
		</div>
		<div class="Boutique">精品课程</div>
		<div id="Boutique1">
			<footer>
				<ul>
					<li v-for="(item, index) in form.excellentCourseList" @click="clickEvents(item.courseId, 1)">
						<img class="Boutique_img" :src="item.imgUrl" />
						<img class="Boutique_img1" src="../../../assets/img/homePage/bf.png" />
						<p style="text-align: left;width: 1.7rem;margin: 0 auto;" v-text="item.title"></p>
						<div class="divss">
							<img :src="item.lecturerHeadImgUrl" />
							<div v-text="item.lecturerName"></div>
						</div>
					</li>
				</ul>
			</footer>
		</div>
		<div class="onlineEducation">在线教育</div>
		<div class="onlineEducation1" :class="sstt[index]" v-for="(item, index) in form.onlineCourseList" @click="clickEvents(item.courseId, 2)">
			<img :src="item.imgUrl" />
			<img class="onlineEducation_img1" src="../../../assets/img/homePage/bf.png" />
			<div class="online_main">
				<div class="online_title" v-text="item.title"></div>
				<div class="online_introduce" v-text="item.ativeTitle"></div>
				<div class="online_btn">去学习</div>
			</div>
		</div>
		<div class="platform_title">已开放平台</div>
		<div class="openPlatform">
			<div class="Platform" @click="xz1" style="border-right: 0.02rem solid #F3F3F4;">
				<img src="../../../assets/img/homePage/1.png" />
				<div>
					洛阳客货运驾
					<br />
					驶员安全教育
				</div>
			</div>
			<div class="Platform" @click="xz">
				<img src="../../../assets/img/homePage/2.png" />
				<div>
					阜阳客货运驾
					<br />
					驶员安全教育
				</div>
			</div>
			<div class="Platform" @click="xz" style="border-right: 0.02rem solid #F3F3F4;">
				<img src="../../../assets/img/homePage/3.png" />
				<div>
					广西客货运驾
					<br />
					驶员安全教育
				</div>
			</div>
			<div class="Platform" @click="xz">
				<img src="../../../assets/img/homePage/4.png" />
				<div>
					广西运输企业安
					<br />
					全管理人员培训
				</div>
			</div>
			<div class="Platform" @click="xz" style="border-right: 0.02rem solid #F3F3F4;">
				<img src="../../../assets/img/homePage/5.png" />
				<div>
					广东施工企业安
					<br />
					全管理人员培训
				</div>
			</div>
			<div class="Platform" @click="xz">
				<img src="../../../assets/img/homePage/6.png" />
				<div>
					登录APP查看
					<br />
					更多系统
				</div>
			</div>
		</div>

		<div class="openClass">
			<div class="openClass1">公开课</div>
			<div class="viewMore" @click="more">查看更多</div>
		</div>
		<div class="publicDetails" v-for="(item, index) in courseList" @click="clickEvents(item.courseId, 3)">
			<img :src="item.logo" />
			<div class="public_main">
				<div class="public_title" v-text="item.name"></div>
				<div class="public_lecturer" v-text="item.lecturerName"></div>
				<div class="public_introduce" v-text="item.introduction"></div>
			</div>
		</div>
		<div class="baseline" v-if="isLoading"><van-loading /></div>
		<div class="baseline" v-if="!isLoading">— 这是我的底线了 —</div>
	</div>
</template>

<script>
import { Toast, Sidebar, List, SidebarItem, PullRefresh, Overlay, Tab, Tabs, Cell, Loading, Card, Dialog } from 'vant';
import navigation from '../../components/navs';
import request from '@/utils/request';
export default {
	components: {
		navigation,
		[Toast.name]: Toast,
		[Sidebar.name]: Sidebar,
		[List.name]: List,
		[SidebarItem.name]: SidebarItem,
		[PullRefresh.name]: PullRefresh,
		[Overlay.name]: Overlay,
		[Tab.name]: Tab,
		[Tabs.name]: Tabs,
		[Cell.name]: Cell,
		[Loading.name]: Loading
	},
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			recordCount: Number, //数据总数
			isLoading: false,
			stop: true,
			form: {
				bannerList: [],
				excellentCourseList: [],
				onlineCourseList: []
				// openCourseList: [],
			},
			courseList: [],
			channeFlag: '2',
			sstt: ['ss1', 'ss2', 'ss3']
		};
	},
	created() {
		this.initData();
		this.initDataList1();
	},
	mounted() {
		let _this = this;
		//	_this.initDataList1()
		window.onscroll = function() {
			let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
			let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
			if (scrollHeight - scrollTop - clientHeight < 100 && (_this.pageNum - 1) * _this.pageSize < _this.recordCount) {
				if (_this.stop) {
					_this.stop = false;
					_this.initDataList1();
				}
			}
		};
	},

	methods: {
		xz1() {
			window.location.href = 'https://ly.zpkjedu.com/';
		},
		// banner点击
		wheelClick(a, b) {
			if (a == '0') {
				// 不可点击
			} else if (a == '1') {
				this.$router.push({
					name: 'PublicCourse',
					query: {
						courseId: b,
						category: '4',
						channeFlag: this.channeFlag
					}
				});
				// 课程ID
			} else if (a == '2') {
				this.$router.push({
					name: 'LecturerPage',
					query: {
						id: b
					}
				});
				// 讲师ID
			} else if (a == '3') {
				// 网页外链
				window.location.href = b;
			}
		},
		clickEvents(a, b) {
			this.$router.push({
				name: 'PublicCourse',
				query: {
					courseId: a,
					category: b,
					channeFlag: this.channeFlag
				}
			});
		},
		more() {
			this.$router.push({
				name: 'publicCourseType',
				query: {}
			});
		},

		xz() {
			window.location.href = 'jt11trafficnews://';
			this.$root.download();
		},
		initData() {
			let _this = this;
			let url = Global.env + Global.apiCore.homePage;
			return new Promise((resolve, reject) => {
				request({
					url: url,
					method: 'get' //查询一般为get
				})
					.then(response => {
						if (response.resultCode === '1000') {
							console.log('**********');
							console.log(response.data);
							console.log('**********');
							_this.form = response.data;
							return resolve();
						} else {
							return reject(response.resultDesc);
						}
					})
					.catch(error => {
						return reject(error);
					});
			});
		},
		initDataList1() {
			//type 1 初始化数据  2 切换tab存储数据id
			let _this = this;
			this.isLoading = true;
			let url = Global.env + Global.apiCore.coursePageList;
			return new Promise((resolve, reject) => {
				request({
					url: url,
					method: 'get', //查询一般为get
					params: {
						pageNum: _this.pageNum,
						pageSize: _this.pageSize
					}
				})
					.then(response => {
						if (response.resultCode === '1000') {
							if (response && response.data) {
								let dataObj = response.data;
								_this.recordCount = dataObj.total;
								if (dataObj.list.length) {
									_this.courseList.push(...dataObj.list);
								}
								if (_this.courseList.length == dataObj.total) {
									this.setTimeLen();
								} else {
									if (dataObj.list.length == 0) {
										this.setTimeLen();
									}
								}
								if (dataObj.total < 11 && _this.pageNum == 1) {
									this.setTimeLen();
								}
								_this.pageNum++;
								_this.stop = true;
							}
							return resolve();
						} else {
							return reject(response.resultDesc);
						}
					})
					.catch(error => {
						return reject(error);
					});
			});
		},
		setTimeLen() {
			setTimeout(() => {
				this.isLoading = false;
			}, 2000);
		}
	}
};
</script>

<style scoped="scoped">
::-webkit-scrollbar {
	display: none;
}

#Boutique1 {
	/*   // flex-direction:column; */
	background: #ccc;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	width: 92%;
	height: 3.8rem;
	overflow: auto;
	margin: 0 auto;
	background: rgba(255, 255, 255, 1);
	box-shadow: 0px 1px 21px 0px rgba(98, 98, 98, 0.1);
	border-radius: 0.2rem;
}

#Boutique1 footer {
	height: auto;
}

#Boutique1 ul {
	display: flex;
	height: 100%;
}

#Boutique1 ul > li {
	width: 2.18rem;
	-webkit-box-flex: 1;
	-ms-flex: 1;
	flex: 1;
	height: 100%;
	/* background: red; */
	overflow: auto;
	overflow-x: hidden;
	position: relative;
}

#Boutique1 ul > li .Boutique_img {
	width: 1.68rem;
	height: 1.68rem;
	border-radius: 0.08rem;
	display: block;
	margin: 0 auto;
	margin-top: 0.18rem;
}

#Boutique1 ul > li .Boutique_img1 {
	width: 0.36rem;
	height: 0.36rem;
	display: block;
	margin: 0 auto;
	position: absolute;
	left: 50%;
	top: 0.84rem;
	transform: translate(-50%, 0);
}

#Boutique1 ul > li p {
	color: #333333;
	font-size: 0.3rem;
	margin: 0 auto;
	min-height: 0.74rem;
	text-align: center;
	margin-top: 0.2rem;
	margin-bottom: 0.1rem;
	margin-left: 0.1rem;
	margin-right: 0.1rem;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

#Boutique1 ul > li .divss img {
	display: block;
	width: 0.38rem;
	height: 0.38rem;
	border-radius: 50%;
	margin-right: 0.2rem;
	float: left;
	margin-top: 0.14rem;
	margin-left: 0.26rem;
}

#Boutique1 ul > li .divss div {
	width: 1rem;
	display: block;
	text-align: left;
	margin: 0 auto;
	padding-top: 0.14rem;
	float: left;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}

#Boutique1 ul > li div {
	color: #999999;
	font-size: 0.28rem;
	margin: 0 auto;
	text-align: center;
	vertical-align: middle;
}

.bigs {
	width: 100%;
	height: 100%;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	background: #fcfcfc;
}

.headers {
	width: 92%;
	height: 1.18rem;
	line-height: 1.18rem;
	margin: 0 auto;
}

.headers img {
	display: block;
	width: 0.6rem;
	height: 0.6rem;
	margin-top: 0.3rem;
	float: left;
}

.headers div {
	float: right;
	font-size: 0.32rem;
	color: #333333;
	margin-left: 0.3rem;
}

.navs {
	width: 92%;
	margin: 0 auto;
}

.navs img {
	width: 100%;
	height: 2.36rem;
}

.Boutique {
	width: 92%;
	margin: 0 auto;
	margin-top: 0.28rem;
	font-size: 0.36rem;
	margin-bottom: 0.28rem;
	font-weight: 400;
	color: rgba(0, 0, 0, 1);
}

.onlineEducation {
	width: 92%;
	margin: 0 auto;
	font-size: 0.36rem;
	margin-top: 0.36rem;
	font-weight: 400;
	color: rgba(0, 0, 0, 1);
}

.platform_title {
	width: 92%;
	margin: 0 auto;
	font-size: 0.36rem;
	line-height: 1rem;
	font-weight: 400;
	color: rgba(0, 0, 0, 1);
}

.openClass {
	width: 92%;
	margin: 0 auto;
}

.openClass1 {
	font-size: 0.36rem;
	line-height: 1rem;
	font-weight: 400;
	color: rgba(0, 0, 0, 1);
	float: left;
}

.viewMore {
	font-size: 0.26rem;
	color: #999999;
	line-height: 1rem;
	font-weight: 400;
	float: right;
}

.publicDetails {
	width: 92%;
	height: 2.08rem;
	margin: 0 auto;
	background: rgba(255, 255, 255, 1);
	box-shadow: 0px 1px 21px 0px rgba(98, 98, 98, 0.1);
	position: relative;
	margin-bottom: 0.3rem;
}

.publicDetails img {
	width: 1.68rem;
	height: 1.68rem;
	border-radius: 0.08rem;
	float: left;
	margin-left: 0.26rem;
	margin-top: 0.2rem;
}

.public_main {
	float: left;
	width: 4.4rem;
	margin-top: 0.18rem;
	margin-left: 0.2rem;
}

.public_title {
	width: 4.16rem;
	line-height: 0.44rem;
	height: 0.84rem;
	font-size: 0.32rem;
	margin-bottom: 0.02rem;
	color: #333333;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

.public_lecturer {
	width: 4.16rem;
	font-size: 0.3rem;
	margin-bottom: 0.02rem;
	color: #666666;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}

.public_introduce {
	width: 4.16rem;
	font-size: 0.3rem;
	color: #999999;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}

/* .onlineEducation1 {
		width: 92%;
		height: 1.9rem;
		margin: 0 auto;
		margin-top: 0.7rem;
		background: fuchsia;
		position: relative;
	} */
.onlineEducation1 {
	width: 92%;
	height: 1.9rem;
	margin: 0 auto;
	margin-top: 0.7rem;
	border-radius: 0.08rem;
	position: relative;
}

.ss1 {
	background: rgba(126, 107, 90, 1);
	box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.6);
}

.ss2 {
	background: linear-gradient(0deg, rgba(84, 84, 84, 1) 0%, rgba(39, 39, 39, 1) 100%);
	box-shadow: 0px 1px 21px 0px rgba(98, 98, 98, 0.1);
}

.ss3 {
	background: linear-gradient(0deg, rgba(74, 72, 67, 1) 0%, rgba(107, 95, 72, 1) 100%);
	box-shadow: 0px 3px 8px 0px rgba(0, 64, 125, 0.6);
}

/* 偶数行 */
.onlineEducation1 img {
	width: 1.42rem;
	height: 1.84rem;
	border-radius: 0.08rem;
	float: left;
	margin-left: 0.26rem;
	margin-top: -0.35rem;
}

.onlineEducation1 .onlineEducation_img1 {
	width: 0.36rem;
	height: 0.36rem;
	display: block;
	margin: 0 auto;
	position: absolute;
	left: 0.78rem;
	top: 0.44rem;
}

.online_main {
	float: left;
	width: 4.4rem;
	margin-top: 0.26rem;
	margin-left: 0.2rem;
}

.online_title {
	width: 4.16rem;
	font-size: 0.34rem;
	color: #ffffff;
	margin-bottom: 0.1rem;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}

.online_introduce {
	width: 4.16rem;
	font-size: 0.3rem;
	color: #ffffff;
	margin-bottom: 0.1rem;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}

.online_btn {
	font-size: 0.26rem;
	color: #ffffff;
	background: url(../../../assets/img/homePage/Hat.png) no-repeat left center;
	background-size: 0.28rem 0.22rem;
	padding-left: 0.3rem;
	float: right;
}

.excellentCourse {
	width: 92%;
	height: 3.7rem;
	margin: 0 auto;
	white-space: nowrap;
	overflow-x: auto;
	background: yellow;
}

.excellentCourse div {
	width: 1.68rem;
	height: 3.7rem;
	display: inline-block;
}

.openPlatform {
	width: 92%;
	height: 4.5rem;
	margin: 0 auto;
	overflow: hidden;
	background: #fff;
	box-shadow: 0px 1px 21px 0px rgba(98, 98, 98, 0.1);
}

.Platform {
	width: 49%;
	min-height: 0.9rem;
	float: left;
	margin: 0.24rem 0;
	border-radius: 0.08rem;
}

.Platform img {
	width: 0.54rem;
	height: 0.52rem;
	display: block;
	float: left;
	margin-top: 0.2rem;
	margin-left: 0.26rem;
}

.Platform div {
	float: left;
	color: #666666;
	font-size: 0.32rem;
	margin-left: 0.2rem;
	line-height: 0.5rem;
}

.baseline {
	width: 100%;
	height: 0.8rem;
	line-height: 0.8rem;
	text-align: center;
	font-size: 0.26rem;
	font-weight: 400;
	color: rgba(153, 153, 153, 1);
}
</style>
